<form [formGroup]="form">
  <common-mojo-tag
    (tagsChange)="addLocation({locations: $event})"
    [autocompleteService]="geolocationService"
    [tags]="locations$ | async"
    [isRequired]="isRequired"
    inputLabel="Location"
    color="accent"
    class="secondary-tag location-margin-unset"
    data-cy="multiple-location-input"
  >
  </common-mojo-tag>
  <mat-error *ngIf="form.get(this.controlName).errors?.isLocation">
    Wrong Locations: {{form.get(this.controlName).errors?.isLocation?.value}}
  </mat-error>
</form>
